import { isNullish } from "./isNullish";

/**
 * Type guard to check if a value is not `null` or `undefined`
 */
export const isNonNullish = <T>(value: T | null | undefined): value is T => {
  return !isNullish(value);
};
